// Card width constants for drag-and-drop layout
export const CARD_WIDTHS = {
  SMALL: 4,   // 1/3 of row (normal card)
  MEDIUM: 8,  // 2/3 of row (large card)
  LARGE: 12,  // full row (largest card)
};

export const MAX_ROW_WIDTH = 12;

// Card height constant for uniform card sizing
// This controls the height of all cards in the drag-and-drop layout
// Change this value to adjust the height of all cards simultaneously
// 
// Files that use this constant:
// - /components/shared/DragDropLayout.js (grid layout dimensions)
// - Any page that uses the DragDropLayout component
//
// Note: The grid layout uses CARD_HEIGHT / 2 for rowHeight calculation
export const CARD_HEIGHT = 421; // Height in pixels

// Default card widths for different card types
export const DEFAULT_CARD_WIDTHS = {
  // Hospital page cards
  hospitalizations: CARD_WIDTHS.SMALL,
  DCERData: CARD_WIDTHS.SMALL,
  insuranceData: CARD_WIDTHS.SMALL,
  returnsData: CARD_WIDTHS.SMALL,
  ninetyDaysData: CARD_WIDTHS.MEDIUM,
  floorsData: CARD_WIDTHS.SMALL,
  doctorData: CARD_WIDTHS.SMALL,
  daysData: CARD_WIDTHS.SMALL,
  dxData: CARD_WIDTHS.SMALL,
  shiftData: CARD_WIDTHS.SMALL,
  nurseData: CARD_WIDTHS.SMALL,
  hospitalData: CARD_WIDTHS.LARGE,

  // Deceased page cards (same as hospital for shared cards)
  deceasedData: CARD_WIDTHS.LARGE,

  // Community Transfer page cards (same as hospital for shared cards)
  sixtyDaysData: CARD_WIDTHS.MEDIUM,
  safeDischargeAssLivData: CARD_WIDTHS.SMALL,
  snfFacilityData: CARD_WIDTHS.SMALL,

  // Add more page cards as needed
};

// Helper function to get card width
export const getCardWidth = (cardType, pageType = null) => {
  if (pageType === 'admission' && cardType === 'hospitalData') {
    return CARD_WIDTHS.SMALL;
  }
  return DEFAULT_CARD_WIDTHS[cardType] || CARD_WIDTHS.SMALL;
};

// Helper function to check if a card can fit in a row
export const canFitInRow = (currentRowWidth, cardWidth) => {
  return currentRowWidth + cardWidth <= MAX_ROW_WIDTH;
};

// Helper function to organize cards into rows
export const organizeCardsIntoRows = (cards) => {
  const rows = [];
  let currentRow = [];
  let currentRowWidth = 0;

  cards.forEach(card => {
    const cardWidth = card.width || getCardWidth(card.id);

    if (canFitInRow(currentRowWidth, cardWidth)) {
      // Card fits in current row
      currentRow.push({ ...card, width: cardWidth });
      currentRowWidth += cardWidth;
    } else {
      // Start new row
      if (currentRow.length > 0) {
        rows.push(currentRow);
      }
      currentRow = [{ ...card, width: cardWidth }];
      currentRowWidth = cardWidth;
    }
  });

  // Add the last row
  if (currentRow.length > 0) {
    rows.push(currentRow);
  }

  return rows;
}; 